import { useGetUserGroupsSuspense } from "api/generated/user-groups/user-groups";

export function useUserGroupsOverviewForUserQuery(userId: number) {
    return useGetUserGroupsSuspense(
        { format: "Overview", "user-id": userId },
        {
            query: {
                select: (response) => {
                    if (response.data.type !== "Overview") {
                        throw new Error(
                            "Expected Overview user groups response"
                        );
                    }
                    return response.data.data.content;
                },
            },
        }
    );
}
